//
// Composant qui fait l'edition du nom du lien dans la sidebar
//

<template>
    <div>
        <h2 class="title">LIEN#{{config.id}}</h2>
        <form @submit.prevent="validate"  @input="saveIt">
            <b-field label="Label" custom-class="is-large">
                <b-input v-model="config.data.label" size="is-large" ref="startFocus"></b-input>
            </b-field>
            <p>Attention: si vous modifez le nom de l'origine de ce lien, cela l'écrasera et il faudra le rechanger</p>
            <hr>
            <b-button  type="is-danger" @click="deleteLink">SUPR</b-button>
        </form>
    </div>
</template>

<script>
    import _ from 'lodash';

    export default {
        name: 'tablien',
        data (){
            return {
            }
        },
        components: {},
        props: ['config'],
        computed: {
        },
        methods: {
            saveIt: _.debounce(function (){
                this.validate()
            }, 2000),

            async validate()
            {
                this.$notification.open('SAUVEGARDE!!')
                await this.$mydb.do.updateLink(this.config)

                this.$store.commit('UPDATELINK',this.config);

            },

            async deleteLink(){
                try {
                    await this.$mydb.do.deleteLink(this.config.id);
                    await this.$store.commit('DELETE_LINK',this.config.data.ref);
                    const toEdit={
                        name:'TabHelp',
                        config:''
                    }
                    this.$store.commit('DROITE_SET',toEdit);
                }
                catch(e) {
                    console.log("Erreur:" + e)
                }
            },

        },
        mounted(){
            this.$refs.startFocus.focus()
        }
    }
</script>


<style lang="scss">

</style>